import { render, staticRenderFns } from "./StockScoreDetailRow.vue?vue&type=template&id=3c6f026d&scoped=true&"
import script from "./StockScoreDetailRow.vue?vue&type=script&lang=js&"
export * from "./StockScoreDetailRow.vue?vue&type=script&lang=js&"
import style0 from "./StockScoreDetailRow.vue?vue&type=style&index=0&id=3c6f026d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f026d",
  null
  
)

export default component.exports